'use strict';
import React from 'react';
import { Navigation } from 'react-router';
import t from 'tcomb-form';
import flux from 'utils/flux';
import dom from 'utils/dom';

var Form = t.form.Form;
var Accept = t.struct({
    termsAccepted: t.subtype(t.Boolean, (s) => s === true)
});

var TermsForm = React.createClass({
    displayName: 'TermsForm',
    mixins: [ Navigation ],
    propTypes: {
        hasError: React.PropTypes.oneOfType([
            React.PropTypes.string,
            React.PropTypes.bool
        ])
    },
    getInitialState() {
        return {
            termsAccepted: false,
            acceptTermsSuccess: false,
            submitting: false
        };
    },
    _setInnerHtml(html) {
        return {__html: html};
    },
    componentWillReceiveProps(nextProps) {
        if (nextProps.hasError && this.state.submitting) {
            this.setState({submitting: false});
        }
    },
    onSubmit(evt) {
        evt.preventDefault();
        var { location } = this.props;
        var acceptData = this.refs.form.getValue();
        acceptData = Object.assign({}, acceptData, {action: 'termsAccepted'});

        if ( acceptData && !!acceptData.termsAccepted ) {
            this.setState({
                submitting: true
            });
            flux.getStore('app').acceptTerms(acceptData)
            .then( () => {
                this.setState({
                    acceptTermsSuccess: true,
                    submitting: false
                });
                var query = this.context.router.getCurrentQuery();
                if ( query.nextPath && query.nextPath.length > 1 ) {
                    this.transitionTo( query.nextPath, {} );
                }
                else {
                    this.replaceWith('landing-page');
                }
            })
            .catch( error => {
                console.error( error );
            });
        }
    },
    renderError() {
        if (this.props.hasError) {
            return (
                <div className="content__error">
                    {this.props.hasError}
                </div>
            );
        }
    },
    onChange(value) {
        this.setState(value);
    },
    render() {
        var options = {
            auto: 'labels',
            template: locals => {
                const { inputs } = locals;
                return (
                    <div className="form__register">
                        <div className="register__tac">
                        <p className="text-light" dangerouslySetInnerHTML={dom.setInnerHtml(flux.t('accept_terms_links'))} />
                        {inputs.termsAccepted}
                        </div>
                    </div>);
            },
            fields: {
                termsAccepted: {
                    type: 'checkbox',
                    error: flux.t('validation_accepted_terms'),
                    label: flux.t('register_accepted_terms')
                }
            }
        };

        return (
            <div>
                <h1>{flux.t('accept_terms_title')}</h1>
                <form onSubmit={this.onSubmit}>
                    <Form
                      ref="form"
                      type={Accept}
                      value={this.state}
                      options={options}
                      onChange={this.onChange}
                    />
                    {this.renderError()}
                    <hr className="white" />
                    <div className="register__submit">
                        <button disabled={this.state.submitting} type="submit" className="btn btn-primary btn-arrow">
                            {flux.t('register_submit')}
                            <i className="chevron-right" />
                        </button>
                    </div>
                    <div className="mejs-clear" />
                </form>
            </div>
        );
    }
});

module.exports = TermsForm;



// WEBPACK FOOTER //
// ./app/pages/acceptTerms/termsForm.jsx